import { render, staticRenderFns } from "./BuildSpecification.vue?vue&type=template&id=f6dc0668&scoped=true"
import script from "./BuildSpecification.vue?vue&type=script&lang=js"
export * from "./BuildSpecification.vue?vue&type=script&lang=js"
import style0 from "./BuildSpecification.vue?vue&type=style&index=0&id=f6dc0668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dc0668",
  null
  
)

export default component.exports